import React from 'react';
import ConnectedHeader, { Header as HeaderContainer } from '../../../../containers/Header';

class Header extends React.Component {
  validateProps({ isTransparent, logoColor }) {
    return typeof isTransparent !== 'boolean' || ['teal', 'white'].indexOf(logoColor) > -1;
  }

  componentDidMount() {
    const { isTransparent, logoColor } = this.props;

    if (!this.validateProps({ isTransparent, logoColor })) {
      throw new Error('Incorrect prop-types for Storyblok Header component');
    }
  }

  render() {
    const { isTransparent, logoColor } = this.props;

    return <ConnectedHeader isTransparent={isTransparent} logoColor={logoColor} />;
  }
}

Header.propTypes = {
  isTransparent: HeaderContainer.propTypes.isTransparent,
  logoColor: HeaderContainer.propTypes.logoColor,
};

Header.defaultProps = {
  isTransparent: HeaderContainer.defaultProps.isTransparent,
  logoColor: HeaderContainer.defaultProps.logoColor,
};

export default Header;
